import {
  faTasks,
  faFileUpload,
  faBan,
  faServer,
  faClipboardList,
  faLaptopCode,
  faCloud,
  faFileInvoiceDollar,
  faFolderOpen,
} from '@fortawesome/free-solid-svg-icons';

const webApps = [
  {
    title: 'Order Manager',
    description: 'Manage and upload customer orders seamlessly.',
    icon: faClipboardList, // 📋 different from faTasks
    path: '/order_manager'
  },
  {
    title: 'Create New Post',
    description: 'Submit Kevin’s Corner or News posts.',
    icon: faFileUpload, // 🗂 upload
    path: '/post_upload',
  },
  {
    title: 'SmartShipper Manager',
    description: 'Moved to Axillon App: manage serial numbers on shipping hold or bypass',
    icon: faClipboardList, // � manage lists
    path: '/smartshipper_blacklist',
  },
  {
    title: 'Applications Management',
    description: 'Track, update, and review all applications.',
    icon: faLaptopCode, // 💻 software/dev related
    path: '/licenses'
  },
  {
    title: 'SFTP File Manager',
    description: 'Upload, download, and manage files on the SFTP server.',
    icon: faServer, // 🖥 server-specific
    path: '/ehs_sftp'
  },
  {
    title: 'Azure Storage Manager',
    description: 'Browse, download, and manage files in Azure Blob Storage.',
    icon: faCloud, // ☁️ cloud storage
    path: '/azure-storage'
  },
  {
    title: 'SUA Generator',
    description: 'Upload vendor payments and generate SUA files.',
    icon: faFileInvoiceDollar,
    path: '/sua'
  },
  {
    title: 'HR Documents',
    description: 'Browse, download, and upload files in the HR document library.',
    icon: faFolderOpen,
    path: '/hr-documents'
  },
  {
    title: 'IT Documents',
    description: 'Browse, download, and upload files in the IT document library.',
    icon: faServer,
    path: '/it-documents'
  },
  {
  title: 'Communications & Policies',
  description: 'View company communications and policies from SharePoint.',
  icon: faFolderOpen,
  path: '/communications-and-policies'
},
{
  title: 'Finance Documents',
  description: 'Browse, download, and upload files in the Finance document library.',
  icon: faFolderOpen,
  path: '/finance-documents'
},
];

export default webApps;